import React, { useEffect } from 'react'
import './AboutUs.scss'
import PageHero from 'src/components/PageHero'
import WhoWeAreImage from '../../assets/images/who-we-are.jpg'
import SimpleWayHiring from '../../assets/images/simple-way-hiring.jpg'
import ExpertiseAcrossTechnologies from '../../assets/images/expertise-across-technologies.png'
import FlexibleEngagement from '../../assets/images/flexible-engagement-models.jpg'
import CollaborativeApproach from '../../assets/images/collaborative-approach.jpg'
import ExcellenceAssured from '../../assets/images/excellence-assured.jpg'
import NearshoreExpertise from '../../assets/images/nearshore-expertise.jpg'
import NearshoreExpertise1h from '../../assets/images/nearshore-expertise-1h.jpg'
import CompetitiveRates from '../../assets/images/competitive-rates.jpg'
import RemoteWorking from '../../assets/images/remote-working.jpg'
import SimplicitySpeed from '../../assets/images/simplicity-speed.jpg'
import NoHiddenCost from '../../assets/images/no-hidden-costs.jpg'
import NoRecruitementCost from '../../assets/images/no-recruitment-costs.jpg'
import IncreasedFlexibility from '../../assets/images/increased-flexibility.jpg'
import FlexibleCancelation from '../../assets/images/flexible-cancelation.jpg'
import Scalability from '../../assets/images/scalability.jpg'


const AboutUs = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  const sectionDescriptionString = `Welcome to ${companyName}, your software contracting specialist.`

  useEffect(() => {
    document.title = 'What we do?'

    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", `At ${companyName}, we are not just team of nearshore software contractors. We dedicate ourselves to delivering innovative, high-quality solutions for our customers.`)
    }
  }, [])

  const whyChooseUs = [
    { image: SimpleWayHiring, title: 'The Simple Way to Hire Specialists', description: 'We provide hassle-free access to expert, cost-effective software developers.' },
    {
      image: ExpertiseAcrossTechnologies,
      title: 'Expertise Across Technologies',
      description: 'We excel in web and mobile development and cloud solutions. We use the latest software and frameworks to stay ahead of the curve.'
    },
    { image: FlexibleEngagement, title: 'Flexible Engagement Models', description: 'We offer flexible contracts to fit your needs. Whether you need a full team, a developer, or a consultant.' },
    {
      image: CollaborativeApproach,
      title: 'Collaborative approach',
      description: 'We integrate seamlessly into your existing team and work together to ensure success at every stage of the project.'
    },
    { image: ExcellenceAssured, title: 'Excellence assured', description: 'We commit to quality. Our work ensures your software is robust, scalable, and secure.' },
    { image: NearshoreExpertise, title: 'Nearshore expertise', description: 'All of our highly skilled developers are nearshore. This delivers significantly reduced labour costs.' }
  ]

  const nearshoreBenefits = [
    {
      image: NearshoreExpertise1h,
      title: 'Nearshore expertise (1hr time difference):',
      description: 'Our highly skilled developers are nearshore. This results in a substantial reduction in labour costs compared to local contractors.'
    },
    { image: CompetitiveRates, title: 'Competitive rates:', description: 'Using our nearshore team ensures you hire expert developers for less. We represent exceptional value for money.' },
    {
      image: SimplicitySpeed,
      title: 'Simplicity and speed:',
      description: 'It is easy to hire a contractor. They can start your project within hours. You have the option to scale your team quickly.'
    },
    { image: NoRecruitementCost, title: 'No recruitment costs:', description: 'There is no engagement fee, eradicating recruitment costs.' },
    { image: RemoteWorking, title: 'Remote working:', description: 'Our talented team are remote workers, reducing your overhead costs. They all work to UK time.' },
    { image: IncreasedFlexibility, title: 'Increased flexibility:', description: 'We offer flexible contracts. You only pay for the work that is scoped and delivered.' },
    { image: Scalability, title: 'Scalability:', description: 'Our adaptable solution enables you to scale your team quickly and utilise the best nearshore talent.' },
    { image: NoHiddenCost, title: 'No hidden costs:', description: 'There are no hidden employee costs. There are no requirements for National Insurance or pension contributions.' },
    { image: FlexibleCancelation, title: 'Flexible cancellation terms:', description: 'We offer a 21-day cancellation policy. There is no termination fee.' }

  ]

  return (
    <>
      <PageHero sectionTitle="What we do" sectionDescription={sectionDescriptionString} />
      <section className="about-us-section about-us-section-first">
        <div className="container">
          <div className="about-us-intro">
            <img className="intro-image" src={WhoWeAreImage} alt="Who We Are" />
            <div className="intro-content">
              <p className="intro-paragraph">
                {companyName} was founded by Iain Gilmore and Nikola Beljanski, two industry experts with 40 years' collective experience. They formed the company to meet the demand for quality,
                agile, and affordable developers for hire.
              </p>
              <p className="intro-paragraph">
                At {companyName}, we are a team of nearshore software contractors. We dedicate ourselves to delivering innovative, high-quality solutions for our customers. We excel in software
                development, system integration, and project management. We work as an extension of your team and bring your ideas to life.
              </p>
              <p className="intro-paragraph">
                Our approach is simple: we listen, understand, and collaborate. We build long-term partnerships with our customers by providing flexible, scalable, and efficient solutions that drive
                results. <br /><br /><strong>At {companyName}, we're not just software contractors, we are your trusted technology partner.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-us-section about-us-section-second black-bck">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="about-us-boxes layout-one">
            {whyChooseUs.map((item, index) => (
              <div className="about-us-box" key={index}>
                <img className="box-image" src={item.image} alt={item.title} />
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-us-section about-us-section-third">
        <div className="container">
          <h2 className="section-title">The Benefits of Nearshore Contracting</h2>
          <div className="section-description">
            <p>{companyName} offers skilled and talented nearshore developers for hire. All our team are located in countries that are just 1 hour ahead and they all work to UK time.</p>
            <p><strong>What is nearshore contracting and what are the benefits?</strong></p>
            <p>Nearshoring is the outsourcing of business processes, especially technology processes, to companies or teams in a nearby country.</p>
            <p>Hiring nearshore developers brings many advantages. They help reduce costs, provide access to global talent, and enable fast scaling. By outsourcing to nearshore regions, you can cut
              labour costs and overheads significantly.</p>
            <p>You will benefit from working with skilled professionals who bring diverse perspectives and expertise. Plus, with teams in different time zones, you can speed up project turnaround
              times.</p>
          </div>
          <h3>Working with TechTonic you will benefit from:</h3>
          <div className="about-us-boxes layout-two">
            {nearshoreBenefits.map((item, index) => (
              <div className="about-us-box" key={index}>
                <img className="box-image" src={item.image} alt={item.title} />
                <p><strong>{item.title}</strong><br />{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-quotes">
        <div className="container">
          <blockquote>
            “We’re passionate about the work we do for our customers and helping them to achieve their project goals. After all, when you succeed, we succeed.”
          </blockquote>
          <span>- Iain Gilmore</span>&nbsp;&nbsp;<span>(Co-Founder)</span>
        </div>
      </section>
    </>
  )
}

export default AboutUs
